import React from 'react';

const RouteErrorScreen = () => {
    return (
        <>

        </>
    )
}

export default RouteErrorScreen
